import { NgModule } from '@angular/core';
import { AvatarComponent } from './avatar/avatar.component';
import { ConfirmationMessagePopUpComponent } from './confirmation-message-pop-up';
import { ErrorPageComponent } from './error-page';
import { LegalLinksComponent } from './footer/legal-links';
import { LoaderComponent } from './loader';
import { SvgSpriteModule } from './svg-sprite';

import { PasswordStrengthMeterModule } from 'angular-password-strength-meter';
import { PasswordStrengthMeterComponent } from './password-strength-meter/password-strength-meter.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@shared/directives/directives.module';
import { RouterModule } from '@angular/router';
import { LanguageSelectorComponent } from './language-selector';
import { TranslateModule } from '@ngx-translate/core';
import { PrimengModule } from '@shared/primeng.module';
import { CopyrightComponent } from './footer';
import { EulaComponent, LegalModalComponent, PrivacyPolicyComponent } from './legal';
import { SdgButtonComponent } from './sdg-button/sdg-button.component';
import { PasswordStrengthLabelComponent } from './password-strength-label/password-strength-label.component';
import { EyeIconComponent } from './eye-icon/eye-icon.component';
import { ToastComponent } from './toast';
import { NotificationMessagePopUpComponent } from './notification-message-pop-up/notification-message-pop-up.component';
import { ButtonComponent, PasswordFieldComponent } from './forms';
import { DefaultButtonComponent } from './buttons';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SvgSpriteModule,
    PasswordStrengthMeterModule.forRoot(),
    TranslateModule,
    PrimengModule,
    DirectivesModule
  ],
  declarations: [
    ErrorPageComponent,
    ConfirmationMessagePopUpComponent,
    PasswordStrengthMeterComponent,
    LegalLinksComponent,
    LegalModalComponent,
    PrivacyPolicyComponent,
    EulaComponent,
    LoaderComponent,
    AvatarComponent,
    LanguageSelectorComponent,
    CopyrightComponent,
    SdgButtonComponent,
    ButtonComponent,
    DefaultButtonComponent,
    PasswordFieldComponent,
    PasswordStrengthLabelComponent, // TODO: remove
    EyeIconComponent, // TODO: remove
    ToastComponent,
    NotificationMessagePopUpComponent
  ],
  exports: [
    SvgSpriteModule,
    PasswordStrengthMeterModule,
    ErrorPageComponent,
    ConfirmationMessagePopUpComponent,
    PasswordStrengthMeterComponent,
    LegalLinksComponent,
    LegalModalComponent,
    PrivacyPolicyComponent,
    EulaComponent,
    LoaderComponent,
    AvatarComponent,
    LanguageSelectorComponent,
    CopyrightComponent,
    SdgButtonComponent,
    ButtonComponent,
    DefaultButtonComponent,
    PasswordFieldComponent,
    PasswordStrengthLabelComponent, // TODO: remove
    EyeIconComponent, // TODO: remove
    ToastComponent,
    NotificationMessagePopUpComponent
  ]
})
export class ComponentsModule {}
